import { render, staticRenderFns } from "./RawTable.vue?vue&type=template&id=0f68fe89"
import script from "./RawTable.vue?vue&type=script&lang=js"
export * from "./RawTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports